import React from "react";
import R14, { View, AsyncStorage, Image, Text } from "../core";
import {requestPushNotification} from "../components/PushNotificationComponent";

import DateUtils from "../utils/DateUtils";
import { CURRENCY, BILL_STATUS, MSG_TYPE, PAGE_PATH, PAM_TYPES, } from "../constant/app.data.constant";

import { CommonString } from "../constant/appCommonText";
import JsonToCSV from "../utils/JsonToCSV";
import HtmlDecode from "../utils/HtmlDecode";
import { commonStyles } from "../assets/css/commonStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import HeaderTitleComponent from "../components/HeaderTitleComponent";
import DashboardColumnTableComponent from "../components/DashboardColumnTableComponent";
import DashboardGridTableComponent from "../components/DashboardGridTableComponent";
import Touchable from "../components/TouchableComponent";
import DashboardHeaderSection from "../components/DashboardHeaderSection";
import CommonUtility from "../utils/CommonUtility";
import attachedFileIcon from"../assets/images/attachedFileIcon.png";

const defaultSec = 60; //60

export default R14.connect(
  class DashboardScreen extends React.Component {
    constructor(props) {
      super(props);
      AsyncStorage.setItem(CommonString.LOCAL_STORAGE_HOMESCREEN, this.props.r14.navigation.activeRouteName);
      this.state = {
        pageData: [],
        totalRows: 0,
        page: 1,
        lastSearchedTxt: "",
        pageReRender: 0,
      }
      this.timerInstance = null;
    }

    componentDidMount() {
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      this.props.app.dm.filterDomain.resetFilter();
      if(isMobileDevice) {
        this.props.app.dm.userSession.setState({ isLoading: true });
        this.getPageData({}, {}, false);
        this.timerInstance = setInterval(async () => {
          const { isSearchOpen } = this.props.app.dm.userSearchDomain.state;
          const { selectedScreen } = this.props.app.dm.dashboard.state;
          if (!!isSearchOpen || selectedScreen !== "RTP") return false;
          else {
            await this.getPageData({}, {}, false);
            this.setState({pageReRender: this.state.pageReRender + 1})
          }
        }, 1000 * defaultSec);
      }
      requestPushNotification(this.props.app);
    }

    componentWillUnmount() {
      if (this.timerInstance) {
        clearInterval(this.timerInstance);
      };
      this.setState({pageData: [], totalRows: 0, page: 1, lastSearchedTxt: "", pageReRender: 0});
    }

    onNavigate = (item) => {
      const { threadId } = item;
      let newThreadId = threadId;
      this.props.app.dm.billDetails.setState({
        billDetails: item
      });
      this.props.app.nav.to("billDetailsRoute", { threadId: newThreadId });
    };

    onFilterStatus = async (ind) => {
      const { statusType } = this.props.app.dm.filterDomain.state;
      const findIdx = statusType.findIndex(status => status.label === ind);
      statusType[findIdx].isSelected = !statusType[findIdx].isSelected;
      this.props.app.dm.filterDomain.setState({ statusType });
      return false;
    };

    onBlockNavigatation = async (type, isPamBlock) => {
      const { newBillCount, overdueBillCount, outstandingBillCount, selectedScreen, newPAMCount, acceptPAMCount, rejectPAMCount } = this.props.app.dm.dashboard.state;
      if (selectedScreen === "RTP") {
        if(isPamBlock && (
          (newPAMCount > 0 && type === PAM_TYPES.NEW) ||
          (acceptPAMCount > 0 && type === PAM_TYPES.ACTIVE) ||
          (rejectPAMCount > 0 && type === PAM_TYPES.DECLINED)
        )) {
          this.props.app.dm.filterDomain.setState({ selectedPamStatus: type, showPAMResetFilterBtn: true });
          this.navigateTo("billersDirectoryRoute");
          return false;
        } else if (
          (newBillCount > 0 && type === "New") ||
          (overdueBillCount > 0 && type === "Overdue") ||
          (outstandingBillCount > 0 && type === "Outstanding")
        ) {
          this.props.app.dm.filterDomain.resetFilter();
          this.onFilterStatus(type);
          this.navigateTo("makePaymentRoutes");
          return false;
        }
      }
    };

    onViewAllNavigation = async () => {
      const { selectedScreen } = this.props.app.dm.dashboard.state;
      if (selectedScreen === "RTP") {
        this.props.app.dm.filterDomain.resetFilter();
        this.navigateTo("makePaymentRoutes");
        return false;
      }
    }

    onBulkPaymentNavigation = async (getData = []) => {
      try {
        let bulkBills = [...getData];
        let billerList = await this.props.app.dm.rest.getBillers();
        bulkBills.forEach((bill) => {
          let biller = billerList.find(x => x.billerId.toLowerCase() === bill.billerId.toLowerCase());
          if (!!biller && !!biller.uid) {
            bill.biller.isPaymentsFull = biller.isPaymentsFull;
            bill.biller.isPaymentsPartial = biller.isPaymentsPartial;
          }
        });

        bulkBills = bulkBills.filter(bill => {
          return (
            !["In Process", 'Declined', 'Paid'].includes(bill.paymentStatus ? bill.paymentStatus : bill.billStatus) &&
            (bill.biller.isPaymentsFull || bill.biller.isPaymentsPartial)
            && !!!bill.isExtentionRequested
            // if isBillerBlocked is true than remove bill from bulk pay
            && !!!bill.biller.isBillerBlocked
          )
        });

        if (!!bulkBills && bulkBills.length > 0) {
          this.props.app.dm.dashboard.setState({ bulkPayBills: bulkBills })
          this.props.app.nav.to("bulkPaymentRoutes")
        } else if (!!bulkBills && bulkBills.length === 0) {
          if (!!getData && getData.length) {
            this.props.app.dm.commonDomain.showToastr("error", CommonString.NoBillApplicable);
          } else this.props.app.dm.commonDomain.showToastr("error", CommonString.NoBillFound);
        }
      } catch (error) {
        console.error(error);
        this.props.app.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);

      }
    };

    showPayType = async (data) => {
      this.props.app.dm.billDetails.setState({
        billDetails: data
      });
      let payType = ((!!data && !!data.biller && !!data.biller.isPaymentsFull) || (!!data.allowedRtpResponseTypes && data.allowedRtpResponseTypes.includes(MSG_TYPE.PAY_ALL))) ? PAGE_PATH.PAYFULL : (!!data && !!data.biller && !!data.biller.isPaymentsPartial) ? PAGE_PATH.PAYPART : "";
      
      if(MSG_TYPE.PAY_PART === data.rtpMessageType && data.amountPaid > 0 && data.amountPaid < data.billAmount && !!data.allowedRtpResponseTypes && data.allowedRtpResponseTypes.includes(MSG_TYPE.PAY_PART))
        payType = PAGE_PATH.PAYPART;

      if (!!payType)
        this.props.app.nav.to("payTypeRoute", { paytype: payType });
      return false;
    }

    toggleBookmark = async (el) => {
      // if we remove bookmark then in next call bookmarked bill will come again
      // then there is no need to remove bookmark
      // return false;
      const { bookmark } = this.props.app.dm.dashboard.state;
      const { pageData } = this.state;

      let pageDataIdx = pageData.findIndex((itm) => itm?.threadId === el.threadId);
      let bookmarkIdx = bookmark.nodes.findIndex((itm) => itm.threadId === el.threadId);
      let res = await this.props.app.dm.dashboard.addUpdateBookmark({
        bookmark: !el.bookmark,
        uid: el.uid,
      });
      if (res.uid) {
        if(res.bookmark === false) {
          delete bookmark.nodes[bookmarkIdx];
          bookmark.totalCount = bookmark.totalCount - 1;
        }
        this.props.app.dm.commonDomain.showToastr("success", !el.bookmark ? CommonString.BillBookmarked : CommonString.BillUnBookmarked);
        this.props.app.dm.dashboard.setState({ bookmark });
        pageData[pageDataIdx].bookmark = res.bookmark;
        this.setState({pageData});
      }
    };

    navigateTo = async (path) => {
      this.props.app.nav.to(path);
    };

    CheckPaymentAllowOrNot = (item) => {
      let isPayNowDistable = true;
      if ([MSG_TYPE.PAY_ALL, MSG_TYPE.REQ_PAY_EXT].includes(item.rtpMessageType) || BILL_STATUS[item.billStatus] || item.billStatus === "In Process") {
        isPayNowDistable = false;
      }
      else if (!!isPayNowDistable && !!item.biller && !!!item.biller.isPaymentsFull && !!!item.biller.isPaymentsPartial) {
        isPayNowDistable = false;
      }

      if(MSG_TYPE.PAY_PART === item.rtpMessageType && item.amountPaid < item.billAmount)
        isPayNowDistable = true;
      
      if (item.billStatus === "Failed" && !!item.biller && (!!item.biller.isPaymentsFull || !!item.biller.isPaymentsPartial)) {
        isPayNowDistable = true;
      }

      return isPayNowDistable;
    }

    convertToCSV = async () => {
      let items = this.state.pageData;
      if (items.length) {
        const { selectedScreen } = this.props.app.dm.dashboard.state;
        if (selectedScreen === "RTP") {
          items = items.map(item => {
            return {
              "Biller Name": item.billerName || item.biller.billerName,
              "Bill Subject": item.subject,
              "Account Number": item.accountNumber || "N/A",
              "Creation Date": DateUtils.formatDate(item.billDate),
              "Due On": DateUtils.formatDate(item.dueDate),
              "Status": item.billStatus,
              "Initial Amount": `${CURRENCY[item.currency]}${item.billAmount ? CommonUtility.formatAmount(item.billAmount.toFixed(2), this.props.app) : CommonUtility.formatAmount(item.billAmount, this.props.app)}`,
              "Paid Amount": `${CURRENCY[item.currency]}${item.amountPaid ? CommonUtility.formatAmount(item.amountPaid.toFixed(2), this.props.app) : CommonUtility.formatAmount(item.amountPaid, this.props.app)}`,
              "Amount Payable": `${CURRENCY[item.currency]}${item.amountDue ? CommonUtility.formatAmount(item.amountDue.toFixed(2), this.props.app) : CommonUtility.formatAmount(item.amountDue, this.props.app)}`,
              "Reference ID": item.endToEndIdentification,
            }
          })
        } else {
          items = items.map(item => {
            return {
              "Biller": item.billerName,
              "Receive Date": DateUtils.formatDate(item.createdOn),
              "Amount": CommonUtility.formatAmount(item.billAmount, this.props.app),
              "Status": item.billStatus,
              "Payment Type": item.paymentType,
              "Expiry Date": DateUtils.formatDate(item.expiryDate)
            }
          })
        }
        const csvContent = JsonToCSV.convertJsonToCSV(items);
        HtmlDecode.downloadUTF8file({
          content: csvContent,
          filename: `Dashboard_${DateUtils.formatYYYYMMDDHHMMSS()}.csv`
        })
      }
      return false;
    }

    getPageData = async (
      query = {},
      options = {},
      loaderShown = true
    ) => {
      try {
        if(loaderShown) this.props.app.dm.userSession.setState({ isLoading: true });
        if (!this.props.app) return { pageData: [], totalRows: 0 };
        const {lastSearchedTxt} = this.state;
        const { page = null, rowsPerPage = 10, sortColumnName, sortDirection, search = null } = query;
        // if search has value then search by search else search by last search state (to prevent data while setTimeout)
        const searchTxt = search === null ? lastSearchedTxt : search;
        const pageNo = page === null ? this.state.page : page;
        let res = !this.props.app ? {} : await this.props.app.dm.dashboard.setCompiledBookmarkMsgList(
          {
            page: pageNo,
            resultsPerPage: rowsPerPage,
            search: searchTxt,
            ...(sortColumnName ? {sort: [{  field: sortColumnName, order: sortDirection.toUpperCase()  }]} : {})
          }
        );

        this.setState({pageData: res.nodes, totalRows: res.totalCount, page: pageNo, lastSearchedTxt: searchTxt});
        return {
          pageData: res.nodes,
          totalRows: res.totalCount
        };
      } catch (error) {
        this.setState({pageData: [], totalRows: 0});
        return {
          pageData: [],
          totalRows: 0,
          lastSearchedTxt: ''
        };
      } finally {
        this.props.app.dm.userSession.setState({ isLoading: false });
      }
    }

    render() {
      let { isBlockNavigation, newBillCount, overdueBillCount, outstandingBillCount, selectedScreen, newPAMCount, acceptPAMCount, rejectPAMCount, } = this.props.app.dm.dashboard.state;
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      
      let acceptBillCount = 0, rejectBillCount = 0;
      if (selectedScreen !== "RTP") {
        newBillCount = this.props.app.dm.sepa.state.newBillCount;
        outstandingBillCount = this.props.app.dm.sepa.state.outstandingBillCount;
        acceptBillCount = this.props.app.dm.sepa.state.acceptBillCount;
        rejectBillCount = this.props.app.dm.sepa.state.rejectBillCount;
      }
      const { pageData, totalRows, page, lastSearchedTxt, pageReRender } = this.state;
      return (
        <>
              <HeaderTitleComponent
                title={"Dashboard"}
                convertToCSV={() => this.convertToCSV("Dashboard")}
                getPageData={this.getPageData}
                isSearchIcon={false}
                isAddMessage={false}
                downloadCsv={false}
                dataSort={false}
                sortingFields={[{key: 'Date', value: 'lastMessageDate'}]}
              />
              {isMobileDevice ? (
              <DashboardHeaderSection
                itemCount={!!pageData && !!pageData.length ? pageData.length : 0}
                onViewAllNavigation={this.onViewAllNavigation}
                onBulkPaymentNavigation={() => this.onBulkPaymentNavigation(pageData)}
                convertToCSV={() => this.convertToCSV(pageData, "Dashboard")}
                getPageData={this.getPageData}
                navigateTo={() => this.navigateTo("dashboard")}
                onBlockNavigatation={(val, isPamBlock) => this.onBlockNavigatation(val, isPamBlock)}
                overdueBillCount={overdueBillCount}
                outstandingBillCount={outstandingBillCount}
                newBillCount={newBillCount}
                acceptBillCount={acceptBillCount}
                rejectBillCount={rejectBillCount}
                newPAMCount={newPAMCount}
                acceptPAMCount={acceptPAMCount}
                rejectPAMCount={rejectPAMCount}
                selectedScreen={selectedScreen}
                isMobileDevice={true}
                searchText={lastSearchedTxt}
              />) : null}
              <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, ]}>
                {isMobileDevice ? (pageReRender >= 1 || pageData.length ? 
                  <DashboardColumnTableComponent
                    onProfileIcon={(item) => this.onNavigate(item)}
                    getPageData={this.getPageData}
                    pageData={pageData}
                    totalRows={totalRows}
                    page={page}
                    rowsPerPage={10}
                    isDashboardScreen={true}
                    message={!!isBlockNavigation ? "No bills to display." : "No priority bills found."}
                    showPayType={this.showPayType}
                    CheckPaymentAllowOrNot={this.CheckPaymentAllowOrNot}
                    toggleBookmark={this.toggleBookmark}
                  /> : null
                ) : (
                  <View style={[commonStyles.flex1, commonStyles.flexDirectionColumn]}>
                  <DashboardHeaderSection
                     itemCount={!!pageData && !!pageData.length ? pageData.length : 0}
                     navigateTo={() => this.navigateTo("dashboard")}
                     onBlockNavigatation={(val, isPamBlock) => this.onBlockNavigatation(val, isPamBlock)}
                     overdueBillCount={overdueBillCount}
                     outstandingBillCount={outstandingBillCount}
                     newBillCount={newBillCount}
                     acceptBillCount={acceptBillCount}
                     rejectBillCount={rejectBillCount}
                     newPAMCount={newPAMCount}
                     acceptPAMCount={acceptPAMCount}
                     rejectPAMCount={rejectPAMCount}
                     selectedScreen={selectedScreen}
                     isMobileDevice={false}
                   />
                <DashboardGridTableComponent
                  name={'clients'}
                  title={"Priority List"}
                  headerTitleTextStyle={[commonFontStyles.workSans, commonStyles.paragraphTextHeader]}
                  labelKeys={[
                    {label: "", width: 35},
                    {label: "Biller"},
                    {label: "Bill Subject"},
                    {label: "Creation Date", },
                    {label: "Due On"},
                    {label: "Status"},
                    {label: "Amount"},
                    {label: "Action", width: 130}
                  ]}
                  labelValues={["bookmark", "biller.billerName", "subject", "billDate", "dueDate", "paymentStatus", "billAmount", "Detail"]}
                  onProfileIcon={(item) => this.onNavigate(item)}
                  message={!!isBlockNavigation ? "No bills to display." : "No priority bills found."}
                  amountTypeFields={["billAmount",]}
                  dateTypeFields={["billDate", "dueDate"]}
                  profileIcon={"biller.billerName"}
                  searchable={true}
                  rowControlsRight={null}
                  getPageData={this.getPageData}
                  autoRefresh={defaultSec}
                  rowsPerPage={10}
                  showPayType={this.showPayType}
                  CheckPaymentAllowOrNot={this.CheckPaymentAllowOrNot}
                  toggleBookmark={this.toggleBookmark}
                  isDashboardScreen={true}
                  billers={[]}
                  headerControlsRight={[ 
                    <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
                      <View tooltip={'Export to CSV'} style={[commonStyles.paddingRight16]} >
                        <Touchable onPress={() => this.convertToCSV()}>
                          <Image source={attachedFileIcon} style={commonStyles.icon18} />
                        </Touchable>
                      </View>
                    </View>,
                    <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
                    <View tooltip={'View All Bills'} style={[commonStyles.paddingRight16]} >
                      <Touchable onPress={() => this.onViewAllNavigation()}>
                      <Text style={[commonMetricsStyle.heading6, commonStyles.fontWeight500, commonStyles.exSmallHeading, commonFontStyles.workSans, responsiveTableStyle.viewAllLink]}>View All</Text>
                      </Touchable>
                    </View>
                  </View>
                  ]}
                />
                </View>
              )}
              </View>
        </>
      );
    }
  }
);
